
  import { computed, defineComponent } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import iframeToggle from "./IframeToggle/index.vue"
  
  export default defineComponent({
    name: 'AppMain',
    components: { iframeToggle },
    setup() {
      const store = useStore()
      const route = useRoute()
      
      const cachedViews = computed(() => store.state.tagsView.cachedViews)
      const key = computed(() => route.path)
      
      return {
        cachedViews,
        key
      }
    }
  })
  